import { defineStore } from 'pinia';

export default defineStore('compare', {
  persist: true,
  state: () => ({
    showCareHomeCompareList: false,
    careHomeCompareList: [],
  }),
  actions: {
    setShowCareHomeCompareList(showCareHomeCompareList) {
      this.showCareHomeCompareList = showCareHomeCompareList;
    },

    setCareHomeCompareList(careHomeCompareList) {
      this.careHomeCompareList = careHomeCompareList;
    },
  },
})
